import React from "react";

import Form from "antd/es/form";
import { useIntl } from "react-intl";

import EntityType from "@mapmycustomers/shared/enum/EntityType";
import { EntityTypesSupportedColumnSelection } from "@mapmycustomers/shared/types/entity";
import { Collapse, CollapsePanel, EntityTypeShapedIcon } from "@mapmycustomers/ui";

import Option from "@app/component/input/LabeledSwitch/Option";

import ColumnPane from "./ColumnPane";
import styles from "./FormItems.module.scss";

const FormItems: React.FC = () => {
  const intl = useIntl();

  return (
    <Option
      description={intl.formatMessage({
        id: "settings.organizationDetails.defaultColumns.description",
        defaultMessage:
          "Enable to set custom default columns for list views and exports for your entire org. Individual users can still change their selections away from default.",
        description:
          "Settings organization details - Default Columns - Default Columns - Description",
      })}
      title={intl.formatMessage({
        id: "settings.organizationDetails.defaultColumns.title",
        defaultMessage: "Customize Default Columns",
        description: "Settings organization details - Default Columns - Default Columns - Title",
      })}
    >
      <Collapse accordion className={styles.collapse} defaultActiveKey={EntityType.COMPANY} ghost>
        {(
          [
            EntityType.COMPANY,
            EntityType.PERSON,
            EntityType.DEAL,
          ] as EntityTypesSupportedColumnSelection[]
        ).map((entityType) => (
          <CollapsePanel
            className={styles.collapseBody}
            header={intl.formatMessage(
              {
                id: "settings.organizationDetails.defaultColumns.collapsePanel.title",
                defaultMessage:
                  "{icon} Default {entityType, select, accounts {Company} contacts {Person} deals {Deal} other {Record}} Columns",
                description:
                  "Title of the collapsible panes in Settings -> Org Details -> Default columns",
              },
              {
                entityType,
                icon: (
                  <EntityTypeShapedIcon className={styles.entityIcon} entityType={entityType} />
                ),
              }
            )}
            key={entityType}
          >
            <div className={styles.paneWrapper}>
              <Form.Item name={["defaultColumns", entityType]}>
                <ColumnPane entityType={entityType} />
              </Form.Item>
            </div>
          </CollapsePanel>
        ))}
      </Collapse>
    </Option>
  );
};

export default FormItems;
